import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsUnblindingReasonServices = {
  //Unblinding Reason
  addNewEIWRSUnblindingReason,
  updateEIWRSUnblindingReasonData,
  deleteEIWRSUnblindingReasonData,
  softDeleteRestoreEIWRSUnblindingReason,
  getEIWRSUnblindingReasonData,
};

// Add New Unblinding Reason
async function addNewEIWRSUnblindingReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSUnblindingReason`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Unblinding Reason
async function updateEIWRSUnblindingReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSUnblindingReasonData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Unblinding Reason
async function softDeleteRestoreEIWRSUnblindingReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSUnblindingReason`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Unblinding Reason
async function deleteEIWRSUnblindingReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSUnblindingReasonData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Unblinding Reason
async function getEIWRSUnblindingReasonData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingReasonData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingReasonData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}